import { Chip, Stack, useMediaQuery } from '@mui/material';
import { TableDisplay } from '../../miscellaneous-components/table-display'
import { TableActionButtons } from '../../miscellaneous-components/table-action-buttons'
import { FunctionComponent, useContext, useState } from 'react';
import { IFileDownload } from '../../../../shared/services/file-download/file-download.model';
import gaiaTheme from '../../../../root-components/theme';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import moment from 'moment';
import CreatePdfService from '../../../../shared/services/create-pdf/create-pdf.service';
import FileDownloadService from '../../../../shared/services/file-download/file-download.service';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';

export const ReportingGaiaDownloadPdfTable: FunctionComponent<{
  fileDownloads: IFileDownload[]
  getDownloads: () => void
  inputPage: number
  setInputPage: React.Dispatch<React.SetStateAction<number>>
  totalRecords: number
  perPage: number
  setPerPage: React.Dispatch<React.SetStateAction<number>>

}> = ({
  fileDownloads,
  getDownloads,
  inputPage,
  setInputPage,
  totalRecords,
  perPage,
  setPerPage
}) => {
    //Services
    const createPdfService = new CreatePdfService();
    const fileDownloadService = new FileDownloadService();
    //Context
    const userNotificationsContext = useContext(UserNotificationsContext)
    //State
    const [selected, setSelected] = useState<string[]>([]);
    //Layout
    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));

    //Table Contents
    const headCells: IHeadCell[] = [
      { id: 'action', numeric: false, label: 'Action', sortable: false, includeInMobile: false },
      { id: 'name', numeric: false, label: 'File Name', sortable: false, isHeading: true },
      { id: 'date', numeric: false, label: 'Created On', sortable: false },
    ];

    const rows = !fileDownloads ? [] : fileDownloads.map(download => {
      const hasAnyFinal = fileDownloads.some(file => file.isFinalVersion)
      return {
        id: download.id,
        name: (
          <Stack display='flex' flexDirection='row' alignContent='center' alignItems='center'>
            {download.filename}
            {download.isFinalVersion && <Chip label='Final Version' variant='outlined' color='primary' sx={{ ml: 2 }} />}
          </Stack>
        ),
        date: moment(download.downloadDate).format('DD/MM/YYYY, HH:mm'),
        action: (
          <TableActionButtons
            id={download.id}
            includeOther={true}
            disableOtherButton={hasAnyFinal}
            otherButtonIcon={IconName.StarBorderOutlined}
            otherButtonText="Make Final Version"
            onOther={(_id: string) => finalVersionHandler(download.id)}
            includeDownload={true}
            includeDelete={true}
            onDownload={() => downloadHandler(download.id)}
            onDelete={() => deleteHandler(download.id)}
          />
        )
      }
    });

    const handleSelected = (selectedRowId: string[]) => {
      if (selectedRowId[0] !== undefined) {
        downloadHandler(selectedRowId[0])
      }
    }

    const downloadHandler = (downloadId: string) => {
      fileDownloadService.getOne(downloadId)
        .then(fileDownload => {
          return fileDownloadService.downloadFile(downloadId, fileDownload.filename)
        })
        .catch(err => {
          console.log(err)
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        })
    }

    const deleteHandler = (downloadId: string) => {
      userNotificationsContext.openDialog({ active: true, title: 'Confirmation', message: `Are you sure you want to delete this file? This action cannot be undone.`, buttonCopy: 'Continue', cancelButtonCopy: 'Cancel' })
        .then(response => {
          if (response) {
            createPdfService.deleteReportPdf(`?fileDownloadId=${downloadId}`)
              .then(response => {
                getDownloads()
                if (inputPage > 0 && fileDownloads && fileDownloads.length === 1) {
                  setInputPage(inputPage - 1)
                } else {
                  getDownloads()
                }
                userNotificationsContext.openSnackbar({ open: true, message: 'Deleted successfully' })
              })
              .catch(err => {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                console.log(err)
              })
          }
        })
    }

    const finalVersionHandler = (downloadId: string) => {
      userNotificationsContext.openDialog({ active: true, title: 'Confirmation', message: `Are you sure you want to mark this file as your final version? You will not be able to create a new report. This action cannot be undone.`, buttonCopy: 'Continue', cancelButtonCopy: 'Cancel' })
        .then(response => {
          if (response) {
            createPdfService.makeFinalReportPdf(`?fileDownloadId=${downloadId}`)
              .then(response => {
                getDownloads()
                userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' })
              })
              .catch(err => {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                console.log(err)
              })
          }
        })
    }

    return (
      <TableDisplay
        isMobileMode={isMobileMode}
        headCells={headCells}
        rows={rows}
        handleSelected={handleSelected}
        haveCheckboxSelect={false}
        selected={selected}
        setSelected={setSelected}
        selectByIcon={true}
        inputPage={inputPage}
        setInputPage={setInputPage}
        totalRecords={totalRecords}
        perPage={perPage}
        setPerPage={setPerPage} />
    )
  }